module.exports = __webpack_public_path__ + "img/沐光.9eae0921.webp";